import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { fundingReportsList } from './types';

import { requestFundingReportsListSuccess, requestFundingReportsListFailure } from './reducer';

const logger = new Logger('Saga:FundingReportsList');

export function* requestFundingReportsListSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(authApiService.get, routerService.generate('api.funding_report'));

    yield put(requestFundingReportsListSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request funding report with the following error', error);
    yield put(requestFundingReportsListFailure(error));
  }
}

export default function* fundingReportListSaga() {
  return yield all([takeLatest(fundingReportsList.request, requestFundingReportsListSaga)]);
}
